import _objectSpread from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapGetters } from 'vuex';
import AiGreeting from './ai-greeting.vue';
import SvgIcon from '@/components/svg-icon.vue';
import QuestionBox from './question-box.vue';
import AnswerBox from './answer-box.vue';
export default {
  components: {
    AnswerBox: AnswerBox,
    QuestionBox: QuestionBox,
    SvgIcon: SvgIcon,
    AiGreeting: AiGreeting
  },
  computed: _objectSpread({}, mapGetters('ai', ['aiChatList', 'guideQuestionList'])),
  methods: {
    sendHandler: function sendHandler(msg) {
      this.$emit('send', msg);
    }
  }
};